import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=2f65d9a4&scoped=true&"
import script from "./FormDetail.vue?vue&type=script&lang=js&"
export * from "./FormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65d9a4",
  null
  
)

export default component.exports